import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import Graphs from "../../components/Reports/Graphs";
import Controls from "../../components/Reports/Controls";
import { Input, Select, DisplayMoney } from "../../components/workspace";
import EmailReportForm from "../../components/EmailReportForm";
import { calcOptionTotal, calcDeposit } from "../../utils/calcOptionTotal";
import { moneyToNumber } from "../../utils/money";

function BusinessReports() {
  const {
    reports,
    payments,
    lists,
    job,
    options,
    indices,
    displayAlert,
    isLoading,
    handleChange,
    handleArrayChanges,
    showReportForm,
  } = useAppContext();
  const index = indices.paymentsIndex;

  const [selectedRow, setSelectedRow] = useState(null);

  const chosenOption = options.filter((opt) => opt.id === job.options_id)[0] || options[0];
  const sales_tax = chosenOption?.sales_tax;

  const handleInput = (e, isNumber) => {
    const property = e.target.name;
    const value = isNumber ? parseInt(e.target.value) : e.target.value;
    const baseArray = [...payments];
    const baseName = "payments";
    handleArrayChanges({
      baseName,
      baseArray,
      index,
      newValues: { [property]: value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="page">
      {/* ----- Reports ------ */}
      <div className="group whole business-reports">
        <form className="form" onSubmit={handleSubmit}>
          <h3>Reports</h3>
          <div className="form-center">
            
            {/* Report Selector and Controls */}
            <Controls />         

            {/* Report Graph */}
            <Graphs />


          </div>
        </form>
      </div>

      {/* ----- Email/ Report Confirmation Modal ------ */}
      <div className={showReportForm ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <EmailReportForm />
        </div>
      </div>
    </div>
  );
}
export default BusinessReports;
